<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <h4 class="font-weight-bold text-dark py">Volunteering Session Details</h4>
                </div>
                <div class="col-md-6 text-right">
                    <button class="btn btn-success btn-sm" (click)="openCreateForm()" data-toggle="modal" data-target="#createCourseModal">Create</button>
                </div>
        </div>
        <div class="card-body">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>S.no</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>From Time</th>
                        <th>To Time</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let session of sessions; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ session.fromDate }}</td>
                        <td>{{ session.toDate }}</td>
                        <td>{{ session.fromTime }}</td>
                        <td>{{ session.toTime }}</td>
                        <td>
                            <button class="btn btn-primary btn-sm" data-toggle="modal" data-target="#createCourseModal" (click)="editCourse(session)">Edit</button>
                            <button class="btn btn-danger btn-sm" (click)="deleteCourse(session)">Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>


<!-- Create Course Modal -->
<div class="modal fade" id="createCourseModal" tabindex="-1" role="dialog" aria-labelledby="createCourseModalLabel">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Create Volunteering Session</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="card-body">
                    <form class="register-form" [formGroup]='createCourseForm' (ngSubmit)="createCourse()" autocomplete="off">
                        <div class="form-group row">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>From Date</label><span class="required"> *</span>
                                <input type="date" class="form-control" formControlName="fromDate" placeholder="Enter From Date">
                                <div *ngIf="createCourseForm.get('fromDate').invalid && createCourseForm.get('fromDate').touched" class="text-danger">
                                    From Date is required.
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>To Date</label><span class="required"> *</span>
                                <input type="date" class="form-control" formControlName="toDate" placeholder="Enter To Date">
                                <div *ngIf="createCourseForm.get('toDate').invalid && createCourseForm.get('toDate').touched" class="text-danger">
                                    To Date is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>From Time</label><span class="required"> *</span>
                                <input type="time" class="form-control" formControlName="fromTime" placeholder="Enter From Time">
                                <div *ngIf="createCourseForm.get('fromTime').invalid && createCourseForm.get('fromTime').touched" class="text-danger">
                                    From Time is required.
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <label>To Time</label><span class="required"> *</span>
                                <input type="time" class="form-control" formControlName="toTime" placeholder="Enter To Time">
                                <div *ngIf="createCourseForm.get('toTime').invalid && createCourseForm.get('toTime').touched" class="text-danger">
                                    To Time is required.
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            
                        </div>
                        <button type="submit" class="btn btn-primary">
                            {{currentSession.id > 0 ? "Update" : "Create"}}</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>